"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionSection = void 0;
const getEnabledQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getEnabledQuestions"));
const getScore_1 = __importDefault(require("@opsbase/lib-form/helpers/getScore"));
const isInSection_1 = __importDefault(require("@opsbase/lib-form/helpers/isInSection"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const InfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/InfoIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Accordion_1 = __importDefault(require("@opsbase/web-ui/Accordion"));
const AccordionDetails_1 = __importDefault(require("@opsbase/web-ui/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@opsbase/web-ui/AccordionSummary"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const InfoPane_1 = __importDefault(require("../../OpPerformQuestionCard/InfoPane"));
const PaneAnswerIcons_1 = __importDefault(require("../../OpPerformQuestionCard/PaneAnswerIcons"));
const PaneTitle_1 = __importDefault(require("../../OpPerformQuestionCard/PaneTitle"));
const OpPerformQuestionHighlight_1 = __importDefault(require("../../OpPerformQuestionHighlight"));
const OpPerformQuestion_1 = __importDefault(require("../OpPerformQuestion"));
const makeMyClasses = () => ({
    textBox: {
        lineHeight: '32px',
        backgroundColor: lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        padding: '8px 16px',
        borderRadius: 8,
        width: '100%',
    },
    divBox: {
        backgroundColor: lib_palette_1.default.LightBlue.main,
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        borderRadius: 16,
        padding: '8px 16px',
    },
    subTitle: {
        color: lib_palette_1.default.GreyBlue.main,
    },
    title: {},
    accordion: {
        backgroundColor: lib_palette_1.default.LightBlue.main,
        '& .MuiExpansionPanelDetails-root': {
            padding: '8px 12px 12px 12px !important',
        },
    },
    inner: {
        width: '100%',
    },
    button: {
        borderRadius: '0',
    },
    skipButton: {
        borderRadius: '0',
        marginLeft: -16,
    },
    bottomBar: {
        marginTop: 4,
        marginBottom: -16,
        width: '100%',
    },
    skippedMessage: {
        backgroundColor: lib_palette_1.default.BorderGrey.main,
        padding: 8,
        margin: 8,
    },
});
const OpPerformQuestionSection = (props, ref) => {
    const { highlightSelected } = props;
    const { question, answer, rule } = (0, usePerformQuestion_1.default)();
    const [qTitle] = (0, useAltForSelfLang_1.default)(question === null || question === void 0 ? void 0 : question.title, question === null || question === void 0 ? void 0 : question.titleAlt);
    const { doSkip } = (0, usePerformQuestionActions_1.default)();
    const { form, isScoreEnabled, isScorePublic, scoreText, isPreview, mode } = (0, usePerform_1.default)();
    const skipped = answer === null || answer === void 0 ? void 0 : answer.notApplicable;
    const { html, files } = rule.richInfo;
    const hasInfo = !!(html === null || html === void 0 ? void 0 : html.length) || !!(files === null || files === void 0 ? void 0 : files.length);
    const self = (0, useSelf_1.default)();
    const [selectedTab, setSelectedTab] = (0, react_1.useState)();
    const viewMode = mode === 'view';
    const isAllowedToSeeScore = (isPreview || viewMode) && (self.isAdmin || self.isPrimary);
    const activeQuestions = (0, getEnabledQuestions_1.default)(question)
        .filter(q => q && !!q.title && q.nodeId !== question.nodeId)
        .filter(q => (0, isInSection_1.default)(form, question, q));
    const hasSubQuestions = activeQuestions === null || activeQuestions === void 0 ? void 0 : activeQuestions.length;
    const [expanded, setExpanded] = (0, react_1.useState)(true);
    const showSkip = !!rule.enableNA && !viewMode;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleExpandAccordion = (0, react_1.useCallback)(() => {
        if (question.parentNodeId === 'root')
            setExpanded(!expanded);
    }, [expanded, question]);
    const scoreTextForThisQuestion = (0, react_1.useMemo)(() => {
        // adding the scoretext here so that we can add it to the depencencies list
        if (isScoreEnabled && (isAllowedToSeeScore || isScorePublic) && scoreText) {
            const score = (0, getScore_1.default)(form, question, false);
            if (score === null || score === void 0 ? void 0 : score.max) {
                return (Math.round((((score.total || 0) / score.max) * 100 + Number.EPSILON) * 100) /
                    100 +
                    '%');
            }
        }
        else
            return null;
    }, [isScoreEnabled, isScorePublic, isAllowedToSeeScore, scoreText, form, question]);
    const toggleShow = (0, useCallforward_1.default)(v => () => {
        setSelectedTab(selectedTab === v ? null : v);
    }, [selectedTab]);
    const handleSkip = (0, react_1.useCallback)(() => doSkip(!answer.notApplicable), [doSkip, answer]);
    const infoContent = (0, react_1.useMemo)(() => {
        if (selectedTab !== 'info')
            return null;
        return react_1.default.createElement(InfoPane_1.default, { onClickClose: toggleShow(null) });
    }, [selectedTab, toggleShow]);
    const skipButton = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Button_1.default, { label: skipped ? lib_i18n_1.default.t('unskip') : lib_i18n_1.default.t('skip'), onClick: handleSkip, classes: { root: myCss.skipButton }, small: true }));
    }, [myCss, handleSkip, skipped]);
    const infoButton = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Button_1.default, { small: true, background: selectedTab === 'info' ? false : 'transparent', color: lib_palette_1.default.secondary, label: lib_i18n_1.default.t('info'), icon: react_1.default.createElement(InfoIcon_1.default, { size: 18 }), classes: { root: myCss.button }, onClick: toggleShow('info') }));
    }, [myCss, selectedTab, toggleShow]);
    return (0, react_1.useMemo)(() => {
        if (!hasSubQuestions)
            return null;
        const summary = (react_1.default.createElement(OpPerformQuestionHighlight_1.default, { highlightSelected: highlightSelected, visible: true },
            react_1.default.createElement(Horizontal_1.default, { paddingY: true, gutter: true },
                react_1.default.createElement(PaneTitle_1.default, { title: qTitle || '', offset: 8, bold: true }),
                react_1.default.createElement(PaneAnswerIcons_1.default, { scoreColor: lib_palette_1.default.secondary, scoreText: scoreTextForThisQuestion }))));
        const details = (react_1.default.createElement(Vertical_1.default, { gutter: true }, activeQuestions === null || activeQuestions === void 0 ? void 0 : activeQuestions.map(questionNode => (react_1.default.createElement(OpPerformQuestion_1.default, { questionNode: questionNode, highlightSelected: highlightSelected })))));
        return question.parentNodeId === 'root' ? (react_1.default.createElement(Pane_1.default, { ref: ref },
            react_1.default.createElement(Accordion_1.default, { classes: { root: myCss.accordion }, expanded: expanded, onChange: handleExpandAccordion },
                react_1.default.createElement(AccordionSummary_1.default, null, summary),
                react_1.default.createElement(AccordionDetails_1.default, null,
                    react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.inner } },
                        !!answer.notApplicable ? (react_1.default.createElement(Pane_1.default, { paddingY: !viewMode, center: true, classes: {
                                root: (0, web_css_1.cx)(!!answer.notApplicable && myCss.skippedMessage),
                            } }, lib_i18n_1.default.t('section-skipped'))) : (details),
                        infoContent,
                        react_1.default.createElement(Horizontal_1.default, { gutter: true, classes: { root: myCss.bottomBar } },
                            showSkip && skipButton,
                            react_1.default.createElement(Pane_1.default, { grow: true }),
                            hasInfo && react_1.default.createElement(Pane_1.default, { right: true }, infoButton))))))) : (react_1.default.createElement(Pane_1.default, { paper: true, classes: { root: myCss.divBox }, ref: ref },
            react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.inner } },
                summary,
                !!answer.notApplicable ? (react_1.default.createElement(Pane_1.default, { paddingY: !viewMode, center: true, classes: {
                        root: (0, web_css_1.cx)(!!answer.notApplicable && myCss.skippedMessage),
                    } }, lib_i18n_1.default.t('section-skipped'))) : (details),
                infoContent,
                react_1.default.createElement(Horizontal_1.default, { gutter: true, classes: { root: myCss.bottomBar } },
                    showSkip && skipButton,
                    react_1.default.createElement(Pane_1.default, { grow: true }),
                    hasInfo && react_1.default.createElement(Pane_1.default, { right: true }, infoButton)))));
    }, [
        hasSubQuestions,
        highlightSelected,
        qTitle,
        scoreTextForThisQuestion,
        activeQuestions,
        question === null || question === void 0 ? void 0 : question.parentNodeId,
        ref,
        myCss === null || myCss === void 0 ? void 0 : myCss.accordion,
        myCss === null || myCss === void 0 ? void 0 : myCss.inner,
        myCss === null || myCss === void 0 ? void 0 : myCss.skippedMessage,
        myCss === null || myCss === void 0 ? void 0 : myCss.bottomBar,
        myCss === null || myCss === void 0 ? void 0 : myCss.divBox,
        expanded,
        handleExpandAccordion,
        answer === null || answer === void 0 ? void 0 : answer.notApplicable,
        viewMode,
        infoContent,
        showSkip,
        skipButton,
        hasInfo,
        infoButton,
    ]);
};
exports.OpPerformQuestionSection = OpPerformQuestionSection;
exports.default = (0, react_1.forwardRef)(exports.OpPerformQuestionSection);
